export const formatPrice = (price: string): string => {
    return price === '0' ? "Gratuit" : price;
};